module.exports = __webpack_public_path__ + "img/javascript.7744269b.svg";